module.exports = __webpack_public_path__ + "img/1.6fc0a142.png";